// extracted by extract-css-chunks-webpack-plugin
module.exports = {"dropDownMenuItem":"dropDowmMenuItem__dropDownMenuItem--3cDe7","itemText":"dropDowmMenuItem__itemText--2qBHy","colorSquare":"dropDowmMenuItem__colorSquare--3WgDq"};